export type Where = { at: number; content: number; window: number };

export const NEAR_THE_END = 24;

export const below = (where: Where): number => Math.max(0, where.content - where.window - where.at);

export const atTheEnd = (where: Where, near = NEAR_THE_END): boolean => below(where) <= near;

export type Reading = { following: boolean };

export const FOLLOWING: Reading = { following: true };

export const scrolled = (where: Where, near = NEAR_THE_END): Reading => ({
  following: atTheEnd(where, near),
});

export const goesToTheEnd = (reading: Reading, rows: number): boolean => rows > 0 && reading.following;
